export const countries = [
  {
    name: "Chile",
    iso: "CL",
    id: 1,
  },
  {
    name: "Argentina",
    iso: "AR",
    id: 9,
  },
  {
    name: "Bolivia",
    iso: "BO",
    id: 3,
  },
  {
    name: "Colombia",
    iso: "CO",
    id: 8,
  },
  {
    name: "Guatemala",
    iso: "GT",
    id: 2,
  },
  {
    name: "México",
    iso: "MX",
    id: 6,
  },
  {
    name: "Paraguay",
    iso: "PY",
    id: 4,
  },
  {
    name: "Perú",
    iso: "PE",
    id: 5,
  },
  {
    name: "Puerto Rico",
    iso: "PR",
    id: 7,
  },
]

export const regions = [
  {
    id: 1,
    name: "I Región",
    alias: "Tarapacá",
    countryId: 1,
    sortOrder: 1,
  },
  {
    id: 2,
    name: "II Región",
    alias: "Antofagasta",
    countryId: 1,
    sortOrder: 2,
  },
  {
    id: 3,
    name: "III Región",
    alias: "Atacama",
    countryId: 1,
    sortOrder: 3,
  },
  {
    id: 4,
    name: "IV Región",
    alias: "Coquimbo",
    countryId: 1,
    sortOrder: 4,
  },
  {
    id: 5,
    name: "V Región",
    alias: "Valparaiso",
    countryId: 1,
    sortOrder: 5,
  },
  {
    id: 6,
    name: "VI Región",
    alias: "del Libertador Gral Bernardo Ohiggins",
    countryId: 1,
    sortOrder: 6,
  },
  {
    id: 7,
    name: "VII Región",
    alias: "del Maule",
    countryId: 1,
    sortOrder: 7,
  },
  {
    id: 8,
    name: "VIII Región",
    alias: "del Bio Bio",
    countryId: 1,
    sortOrder: 8,
  },
  {
    id: 9,
    name: "IX Región",
    alias: "de la Araucanía",
    countryId: 1,
    sortOrder: 9,
  },
  {
    id: 10,
    name: "X Región",
    alias: "de los Lagos",
    countryId: 1,
    sortOrder: 10,
  },
  {
    id: 11,
    name: "XI Región",
    alias: "Aysén del Gral Carlos Ibañez del Campo",
    countryId: 1,
    sortOrder: 11,
  },
  {
    id: 12,
    name: "XII Región",
    alias: "Magallanes",
    countryId: 1,
    sortOrder: 12,
  },
  {
    id: 13,
    name: "Región Metropolitana",
    alias: "",
    countryId: 1,
    sortOrder: -1,
  },
  {
    id: 14,
    name: "XIV Región",
    alias: "de Los Rios",
    countryId: 1,
    sortOrder: 11,
  },
  {
    id: 15,
    name: "XV Región",
    alias: "Arica y Parinacota",
    countryId: 1,
    sortOrder: 0,
  },
  {
    id: 16,
    name: "XVI Región",
    alias: "de Ñuble",
    countryId: 1,
    sortOrder: 6,
  },
  {
    id: 17,
    name: "Alta Verapaz",
    alias: null,
    countryId: 2,
    sortOrder: 1,
  },
  {
    id: 18,
    name: "Baja Verapaz",
    alias: null,
    countryId: 2,
    sortOrder: 2,
  },
  {
    id: 19,
    name: "Chimaltenango",
    alias: null,
    countryId: 2,
    sortOrder: 3,
  },
  {
    id: 20,
    name: "Chiquimula",
    alias: null,
    countryId: 2,
    sortOrder: 4,
  },
  {
    id: 21,
    name: "El Progreso",
    alias: null,
    countryId: 2,
    sortOrder: 5,
  },
  {
    id: 22,
    name: "Escuintla",
    alias: null,
    countryId: 2,
    sortOrder: 6,
  },
  {
    id: 23,
    name: "Guatemala",
    alias: null,
    countryId: 2,
    sortOrder: 7,
  },
  {
    id: 24,
    name: "Huehuetenango",
    alias: null,
    countryId: 2,
    sortOrder: 8,
  },
  {
    id: 25,
    name: "Izabal",
    alias: null,
    countryId: 2,
    sortOrder: 9,
  },
  {
    id: 26,
    name: "Jalapa",
    alias: null,
    countryId: 2,
    sortOrder: 10,
  },
  {
    id: 27,
    name: "Jutiapa",
    alias: null,
    countryId: 2,
    sortOrder: 11,
  },
  {
    id: 28,
    name: "Petén",
    alias: null,
    countryId: 2,
    sortOrder: 12,
  },
  {
    id: 29,
    name: "Quetzaltenango",
    alias: null,
    countryId: 2,
    sortOrder: 13,
  },
  {
    id: 30,
    name: "Quiché",
    alias: null,
    countryId: 2,
    sortOrder: 14,
  },
  {
    id: 31,
    name: "Retalhuleu",
    alias: null,
    countryId: 2,
    sortOrder: 15,
  },
  {
    id: 32,
    name: "Sacatepéquez",
    alias: null,
    countryId: 2,
    sortOrder: 16,
  },
  {
    id: 33,
    name: "San Marcos",
    alias: null,
    countryId: 2,
    sortOrder: 17,
  },
  {
    id: 34,
    name: "Santa Rosa",
    alias: null,
    countryId: 2,
    sortOrder: 18,
  },
  {
    id: 35,
    name: "Sololá",
    alias: null,
    countryId: 2,
    sortOrder: 19,
  },
  {
    id: 36,
    name: "Suchitepéquez",
    alias: null,
    countryId: 2,
    sortOrder: 20,
  },
  {
    id: 37,
    name: "Totonicapán",
    alias: null,
    countryId: 2,
    sortOrder: 21,
  },
  {
    id: 38,
    name: "Zacapa",
    alias: null,
    countryId: 2,
    sortOrder: 22,
  },
  {
    id: 39,
    name: "Cochabamba",
    alias: null,
    countryId: 3,
    sortOrder: 1,
  },
  {
    id: 40,
    name: "Chuquisaca",
    alias: null,
    countryId: 3,
    sortOrder: 2,
  },
  {
    id: 41,
    name: "El Beni",
    alias: null,
    countryId: 3,
    sortOrder: 3,
  },
  {
    id: 42,
    name: "La Paz",
    alias: null,
    countryId: 3,
    sortOrder: 4,
  },
  {
    id: 43,
    name: "Oruro",
    alias: null,
    countryId: 3,
    sortOrder: 5,
  },
  {
    id: 44,
    name: "Pando",
    alias: null,
    countryId: 3,
    sortOrder: 6,
  },
  {
    id: 45,
    name: "Potosí",
    alias: null,
    countryId: 3,
    sortOrder: 7,
  },
  {
    id: 46,
    name: "Santa Cruz",
    alias: null,
    countryId: 3,
    sortOrder: 8,
  },
  {
    id: 47,
    name: "Tarija",
    alias: null,
    countryId: 3,
    sortOrder: 9,
  },
  {
    id: 48,
    name: "Asunción",
    alias: null,
    countryId: 4,
    sortOrder: 1,
  },
  {
    id: 49,
    name: "Alto Paraguay",
    alias: null,
    countryId: 4,
    sortOrder: 2,
  },
  {
    id: 50,
    name: "Alto Paraná",
    alias: null,
    countryId: 4,
    sortOrder: 3,
  },
  {
    id: 51,
    name: "Amambay",
    alias: null,
    countryId: 4,
    sortOrder: 4,
  },
  {
    id: 52,
    name: "Boquerón",
    alias: null,
    countryId: 4,
    sortOrder: 5,
  },
  {
    id: 53,
    name: "Caaguazú",
    alias: null,
    countryId: 4,
    sortOrder: 6,
  },
  {
    id: 54,
    name: "Caazapá",
    alias: null,
    countryId: 4,
    sortOrder: 7,
  },
  {
    id: 55,
    name: "Canindeyú",
    alias: null,
    countryId: 4,
    sortOrder: 8,
  },
  {
    id: 56,
    name: "Central",
    alias: null,
    countryId: 4,
    sortOrder: 9,
  },
  {
    id: 57,
    name: "Concepción",
    alias: null,
    countryId: 4,
    sortOrder: 10,
  },
  {
    id: 58,
    name: "Cordillera",
    alias: null,
    countryId: 4,
    sortOrder: 11,
  },
  {
    id: 59,
    name: "Guairá",
    alias: null,
    countryId: 4,
    sortOrder: 12,
  },
  {
    id: 60,
    name: "Itapúa",
    alias: null,
    countryId: 4,
    sortOrder: 13,
  },
  {
    id: 61,
    name: "Misiones",
    alias: null,
    countryId: 4,
    sortOrder: 14,
  },
  {
    id: 62,
    name: "Ñeembucú",
    alias: null,
    countryId: 4,
    sortOrder: 15,
  },
  {
    id: 63,
    name: "Paraguarí",
    alias: null,
    countryId: 4,
    sortOrder: 16,
  },
  {
    id: 64,
    name: "Presidente Hayes",
    alias: null,
    countryId: 4,
    sortOrder: 17,
  },
  {
    id: 65,
    name: "San Pedro",
    alias: null,
    countryId: 4,
    sortOrder: 18,
  },
  {
    id: 66,
    name: "Amazonas",
    alias: null,
    countryId: 5,
    sortOrder: 1,
  },
  {
    id: 67,
    name: "Ancash",
    alias: null,
    countryId: 5,
    sortOrder: 2,
  },
  {
    id: 68,
    name: "Apurímac",
    alias: null,
    countryId: 5,
    sortOrder: 3,
  },
  {
    id: 69,
    name: "Arequipa",
    alias: null,
    countryId: 5,
    sortOrder: 4,
  },
  {
    id: 70,
    name: "Ayacucho",
    alias: null,
    countryId: 5,
    sortOrder: 5,
  },
  {
    id: 71,
    name: "Cajamarca",
    alias: null,
    countryId: 5,
    sortOrder: 6,
  },
  {
    id: 72,
    name: "Cusco",
    alias: null,
    countryId: 5,
    sortOrder: 7,
  },
  {
    id: 73,
    name: "El Callao",
    alias: null,
    countryId: 5,
    sortOrder: 8,
  },
  {
    id: 74,
    name: "Huancavelica",
    alias: null,
    countryId: 5,
    sortOrder: 9,
  },
  {
    id: 75,
    name: "Huánuco",
    alias: null,
    countryId: 5,
    sortOrder: 10,
  },
  {
    id: 76,
    name: "Ica",
    alias: null,
    countryId: 5,
    sortOrder: 11,
  },
  {
    id: 77,
    name: "Junín",
    alias: null,
    countryId: 5,
    sortOrder: 12,
  },
  {
    id: 78,
    name: "La Libertad",
    alias: null,
    countryId: 5,
    sortOrder: 13,
  },
  {
    id: 79,
    name: "Lambayeque",
    alias: null,
    countryId: 5,
    sortOrder: 14,
  },
  {
    id: 80,
    name: "Lima",
    alias: null,
    countryId: 5,
    sortOrder: 15,
  },
  {
    id: 81,
    name: "Loreto",
    alias: null,
    countryId: 5,
    sortOrder: 16,
  },
  {
    id: 82,
    name: "Madre de Dios",
    alias: null,
    countryId: 5,
    sortOrder: 17,
  },
  {
    id: 83,
    name: "Moquegua",
    alias: null,
    countryId: 5,
    sortOrder: 18,
  },
  {
    id: 84,
    name: "Pasco",
    alias: null,
    countryId: 5,
    sortOrder: 19,
  },
  {
    id: 85,
    name: "Piura",
    alias: null,
    countryId: 5,
    sortOrder: 20,
  },
  {
    id: 86,
    name: "Puno",
    alias: null,
    countryId: 5,
    sortOrder: 21,
  },
  {
    id: 87,
    name: "San Martín",
    alias: null,
    countryId: 5,
    sortOrder: 22,
  },
  {
    id: 88,
    name: "Tacna",
    alias: null,
    countryId: 5,
    sortOrder: 23,
  },
  {
    id: 89,
    name: "Tumbes",
    alias: null,
    countryId: 5,
    sortOrder: 24,
  },
  {
    id: 90,
    name: "Ucayali",
    alias: null,
    countryId: 5,
    sortOrder: 25,
  },
  {
    id: 91,
    name: "Ciudad de Mexico",
    alias: null,
    countryId: 6,
    sortOrder: 1,
  },
  {
    id: 92,
    name: "Aguascalientes",
    alias: null,
    countryId: 6,
    sortOrder: 2,
  },
  {
    id: 93,
    name: "Baja California",
    alias: null,
    countryId: 6,
    sortOrder: 3,
  },
  {
    id: 94,
    name: "Baja California Sur",
    alias: null,
    countryId: 6,
    sortOrder: 4,
  },
  {
    id: 95,
    name: "Campeche",
    alias: null,
    countryId: 6,
    sortOrder: 5,
  },
  {
    id: 96,
    name: "Coahuila",
    alias: null,
    countryId: 6,
    sortOrder: 6,
  },
  {
    id: 97,
    name: "Colima",
    alias: null,
    countryId: 6,
    sortOrder: 7,
  },
  {
    id: 98,
    name: "Chiapas",
    alias: null,
    countryId: 6,
    sortOrder: 8,
  },
  {
    id: 99,
    name: "Chihuahua",
    alias: null,
    countryId: 6,
    sortOrder: 9,
  },
  {
    id: 100,
    name: "Durango",
    alias: null,
    countryId: 6,
    sortOrder: 10,
  },
  {
    id: 101,
    name: "Guanajuato",
    alias: null,
    countryId: 6,
    sortOrder: 11,
  },
  {
    id: 102,
    name: "Guerrero",
    alias: null,
    countryId: 6,
    sortOrder: 12,
  },
  {
    id: 103,
    name: "Hidalgo",
    alias: null,
    countryId: 6,
    sortOrder: 13,
  },
  {
    id: 104,
    name: "Jalisco",
    alias: null,
    countryId: 6,
    sortOrder: 14,
  },
  {
    id: 105,
    name: "México",
    alias: null,
    countryId: 6,
    sortOrder: 15,
  },
  {
    id: 106,
    name: "Michoacán",
    alias: null,
    countryId: 6,
    sortOrder: 16,
  },
  {
    id: 107,
    name: "Morelos",
    alias: null,
    countryId: 6,
    sortOrder: 17,
  },
  {
    id: 108,
    name: "Nayarit",
    alias: null,
    countryId: 6,
    sortOrder: 18,
  },
  {
    id: 109,
    name: "Nuevo León",
    alias: null,
    countryId: 6,
    sortOrder: 19,
  },
  {
    id: 110,
    name: "Oaxaca",
    alias: null,
    countryId: 6,
    sortOrder: 20,
  },
  {
    id: 111,
    name: "Puebla",
    alias: null,
    countryId: 6,
    sortOrder: 21,
  },
  {
    id: 112,
    name: "Querétaro",
    alias: null,
    countryId: 6,
    sortOrder: 22,
  },
  {
    id: 113,
    name: "Quintana Roo",
    alias: null,
    countryId: 6,
    sortOrder: 23,
  },
  {
    id: 114,
    name: "San Luis Potosí",
    alias: null,
    countryId: 6,
    sortOrder: 24,
  },
  {
    id: 115,
    name: "Sinaloa",
    alias: null,
    countryId: 6,
    sortOrder: 25,
  },
  {
    id: 116,
    name: "Sonora",
    alias: null,
    countryId: 6,
    sortOrder: 26,
  },
  {
    id: 117,
    name: "Tabasco",
    alias: null,
    countryId: 6,
    sortOrder: 27,
  },
  {
    id: 118,
    name: "Tamaulipas",
    alias: null,
    countryId: 6,
    sortOrder: 28,
  },
  {
    id: 119,
    name: "Tlaxcala",
    alias: null,
    countryId: 6,
    sortOrder: 29,
  },
  {
    id: 120,
    name: "Veracruz",
    alias: null,
    countryId: 6,
    sortOrder: 30,
  },
  {
    id: 121,
    name: "Yucatán",
    alias: null,
    countryId: 6,
    sortOrder: 31,
  },
  {
    id: 122,
    name: "Zacatecas",
    alias: null,
    countryId: 6,
    sortOrder: 32,
  },
  {
    id: 123,
    name: "San Juan",
    alias: null,
    countryId: 7,
    sortOrder: 8,
  },
  {
    id: 124,
    name: "Bayamón",
    alias: null,
    countryId: 7,
    sortOrder: 3,
  },
  {
    id: 125,
    name: "Arecibo",
    alias: null,
    countryId: 7,
    sortOrder: 2,
  },
  {
    id: 126,
    name: "Aguadilla/ Mayagüez",
    alias: null,
    countryId: 7,
    sortOrder: 1,
  },
  {
    id: 127,
    name: "Ponce",
    alias: null,
    countryId: 7,
    sortOrder: 7,
  },
  {
    id: 128,
    name: "Guayama",
    alias: null,
    countryId: 7,
    sortOrder: 5,
  },
  {
    id: 129,
    name: "Humacao",
    alias: null,
    countryId: 7,
    sortOrder: 6,
  },
  {
    id: 130,
    name: "Carolina",
    alias: null,
    countryId: 7,
    sortOrder: 4,
  },
  {
    id: 131,
    name: "Distrito I",
    alias: "Amazonas",
    countryId: 8,
    sortOrder: 0,
  },
  {
    id: 132,
    name: "Distrito II",
    alias: "Antioquia",
    countryId: 8,
    sortOrder: 1,
  },
  {
    id: 133,
    name: "Distrito III",
    alias: "Arauca",
    countryId: 8,
    sortOrder: 2,
  },
  {
    id: 134,
    name: "Distrito V",
    alias: "Atlántico",
    countryId: 8,
    sortOrder: 4,
  },
  {
    id: 135,
    name: "Distrito VIII",
    alias: "Caldas",
    countryId: 8,
    sortOrder: 8,
  },
  {
    id: 136,
    name: "Distrito IX",
    alias: "Caquetá",
    countryId: 8,
    sortOrder: 9,
  },
  {
    id: 137,
    name: "Distrito X",
    alias: "Casanare",
    countryId: 8,
    sortOrder: 10,
  },
  {
    id: 138,
    name: "Distrito XI",
    alias: "Cauca",
    countryId: 8,
    sortOrder: 11,
  },
  {
    id: 139,
    name: "Distrito XII",
    alias: "César",
    countryId: 8,
    sortOrder: 12,
  },
  {
    id: 140,
    name: "Distrito XIII",
    alias: "Chocó",
    countryId: 8,
    sortOrder: 13,
  },
  {
    id: 141,
    name: "Distrito XIV",
    alias: "Córdoba",
    countryId: 8,
    sortOrder: 14,
  },
  {
    id: 142,
    name: "Distrito XV",
    alias: "Cundinamarca",
    countryId: 8,
    sortOrder: 15,
  },
  {
    id: 143,
    name: "Distrito Capital",
    alias: "BOGOTA- D.C.",
    countryId: 8,
    sortOrder: 5,
  },
  {
    id: 144,
    name: "Distrito XVI",
    alias: "Guainía",
    countryId: 8,
    sortOrder: 16,
  },
  {
    id: 145,
    name: "Distrito XVII",
    alias: "Guaviare",
    countryId: 8,
    sortOrder: 17,
  },
  {
    id: 146,
    name: "Distrito XVIII",
    alias: "Huila",
    countryId: 8,
    sortOrder: 18,
  },
  {
    id: 147,
    name: "Distrito XIX",
    alias: "La Guajira",
    countryId: 8,
    sortOrder: 19,
  },
  {
    id: 148,
    name: "Distrito XX",
    alias: "Magdalena",
    countryId: 8,
    sortOrder: 20,
  },
  {
    id: 149,
    name: "Distrito XXI",
    alias: "Meta",
    countryId: 8,
    sortOrder: 21,
  },
  {
    id: 150,
    name: "Distrito XXII",
    alias: "Nariño",
    countryId: 8,
    sortOrder: 22,
  },
  {
    id: 151,
    name: "Distrito XXIII",
    alias: "Norte de Santander",
    countryId: 8,
    sortOrder: 23,
  },
  {
    id: 152,
    name: "Distrito XXIV",
    alias: "Putumayo",
    countryId: 8,
    sortOrder: 24,
  },
  {
    id: 153,
    name: "Distrito XXV",
    alias: "Quindío",
    countryId: 8,
    sortOrder: 25,
  },
  {
    id: 154,
    name: "Distrito XXVI",
    alias: "Risaralda",
    countryId: 8,
    sortOrder: 26,
  },
  {
    id: 155,
    name: "Distrito IV",
    alias: "San Andrés y Providencia",
    countryId: 8,
    sortOrder: 3,
  },
  {
    id: 156,
    name: "Distrito XXVII",
    alias: "Santander",
    countryId: 8,
    sortOrder: 27,
  },
  {
    id: 157,
    name: "Distrito XXVIII",
    alias: "Sucre",
    countryId: 8,
    sortOrder: 28,
  },
  {
    id: 158,
    name: "Distrito XXIX",
    alias: "Tolima",
    countryId: 8,
    sortOrder: 29,
  },
  {
    id: 159,
    name: "Distrito XXX",
    alias: "Valle del Cauca",
    countryId: 8,
    sortOrder: 30,
  },
  {
    id: 160,
    name: "Distrito XXXI",
    alias: "Vaupés",
    countryId: 8,
    sortOrder: 31,
  },
  {
    id: 161,
    name: "Distrito XXXII",
    alias: "Vichada",
    countryId: 8,
    sortOrder: 32,
  },
  {
    id: 162,
    name: "Distrito VI",
    alias: "Bolívar",
    countryId: 8,
    sortOrder: 6,
  },
  {
    id: 163,
    name: "Distrito I",
    alias: "AMAZONAS",
    countryId: 8,
    sortOrder: 0,
  },
  {
    id: 164,
    name: "Distrito II",
    alias: "ANTIOQUIA",
    countryId: 8,
    sortOrder: 1,
  },
  {
    id: 165,
    name: "Distrito III",
    alias: "ARAUCA",
    countryId: 8,
    sortOrder: 2,
  },
  {
    id: 166,
    name: "Distrito IV",
    alias: "ARCHIPIELAGO DE SAN ANDRES",
    countryId: 8,
    sortOrder: 3,
  },
  {
    id: 167,
    name: "Distrito V",
    alias: "ATLANTICO",
    countryId: 8,
    sortOrder: 4,
  },
  {
    id: 168,
    name: "Distrito Capital",
    alias: "BOGOTA- D.C.",
    countryId: 8,
    sortOrder: 5,
  },
  {
    id: 169,
    name: "Distrito VI",
    alias: "BOLIVAR",
    countryId: 8,
    sortOrder: 6,
  },
  {
    id: 170,
    name: "Distrito VII",
    alias: "Boyaca",
    countryId: 8,
    sortOrder: 7,
  },
  {
    id: 171,
    name: "Distrito VIII",
    alias: "CALDAS",
    countryId: 8,
    sortOrder: 8,
  },
  {
    id: 172,
    name: "Distrito IX",
    alias: "CAQUETA",
    countryId: 8,
    sortOrder: 9,
  },
  {
    id: 173,
    name: "Distrito X",
    alias: "CASANARE",
    countryId: 8,
    sortOrder: 10,
  },
  {
    id: 174,
    name: "Distrito XI",
    alias: "CAUCA",
    countryId: 8,
    sortOrder: 11,
  },
  {
    id: 175,
    name: "Distrito XII",
    alias: "CESAR",
    countryId: 8,
    sortOrder: 12,
  },
  {
    id: 176,
    name: "Distrito XIII",
    alias: "CHOCO",
    countryId: 8,
    sortOrder: 13,
  },
  {
    id: 177,
    name: "Distrito XIV",
    alias: "CORDOBA",
    countryId: 8,
    sortOrder: 14,
  },
  {
    id: 178,
    name: "Distrito XV",
    alias: "CUNDINAMARCA",
    countryId: 8,
    sortOrder: 15,
  },
  {
    id: 179,
    name: "Distrito XVI",
    alias: "GUAINIA",
    countryId: 8,
    sortOrder: 16,
  },
  {
    id: 180,
    name: "Distrito XVII",
    alias: "GUAVIARE",
    countryId: 8,
    sortOrder: 17,
  },
  {
    id: 181,
    name: "Distrito XVIII",
    alias: "HUILA",
    countryId: 8,
    sortOrder: 18,
  },
  {
    id: 182,
    name: "Distrito XIX",
    alias: "LA GUAJIRA",
    countryId: 8,
    sortOrder: 19,
  },
  {
    id: 183,
    name: "Distrito XX",
    alias: "MAGDALENA",
    countryId: 8,
    sortOrder: 20,
  },
  {
    id: 184,
    name: "Distrito XXI",
    alias: "META",
    countryId: 8,
    sortOrder: 21,
  },
  {
    id: 185,
    name: "Distrito XXII",
    alias: "NARIÑO",
    countryId: 8,
    sortOrder: 22,
  },
  {
    id: 186,
    name: "Distrito XXIII",
    alias: "NORTE DE SANTANDER",
    countryId: 8,
    sortOrder: 23,
  },
  {
    id: 187,
    name: "Distrito XXIV",
    alias: "PUTUMAYO",
    countryId: 8,
    sortOrder: 24,
  },
  {
    id: 188,
    name: "Distrito XXV",
    alias: "QUINDIO",
    countryId: 8,
    sortOrder: 25,
  },
  {
    id: 189,
    name: "Distrito XXVI",
    alias: "RISARALDA",
    countryId: 8,
    sortOrder: 26,
  },
  {
    id: 190,
    name: "Distrito XXVII",
    alias: "SANTANDER",
    countryId: 8,
    sortOrder: 27,
  },
  {
    id: 191,
    name: "Distrito XXVIII",
    alias: "SUCRE",
    countryId: 8,
    sortOrder: 28,
  },
  {
    id: 192,
    name: "Distrito XXIX",
    alias: "TOLIMA",
    countryId: 8,
    sortOrder: 29,
  },
  {
    id: 193,
    name: "Distrito XXX",
    alias: "VALLE DEL CAUCA",
    countryId: 8,
    sortOrder: 30,
  },
  {
    id: 194,
    name: "Distrito XXXI",
    alias: "VAUPES",
    countryId: 8,
    sortOrder: 31,
  },
  {
    id: 195,
    name: "Distrito XXXII",
    alias: "VICHADA",
    countryId: 8,
    sortOrder: 32,
  },
  {
    id: 196,
    name: "Buenos Aires",
    alias: null,
    countryId: 9,
    sortOrder: 1,
  },
  {
    id: 197,
    name: "Mendoza",
    alias: null,
    countryId: 9,
    sortOrder: 2,
  },
  {
    id: 198,
    name: "Catamarca",
    alias: null,
    countryId: 9,
    sortOrder: 3,
  },
  {
    id: 199,
    name: "Chaco",
    alias: null,
    countryId: 9,
    sortOrder: 4,
  },
  {
    id: 200,
    name: "Chubut",
    alias: null,
    countryId: 9,
    sortOrder: 5,
  },
  {
    id: 201,
    name: "Córdoba",
    alias: null,
    countryId: 9,
    sortOrder: 6,
  },
  {
    id: 202,
    name: "Corrientes",
    alias: null,
    countryId: 9,
    sortOrder: 7,
  },
  {
    id: 203,
    name: "Entre Ríos",
    alias: null,
    countryId: 9,
    sortOrder: 8,
  },
  {
    id: 204,
    name: "Formosa",
    alias: null,
    countryId: 9,
    sortOrder: 9,
  },
  {
    id: 205,
    name: "Jujuy",
    alias: null,
    countryId: 9,
    sortOrder: 10,
  },
  {
    id: 206,
    name: "La Pampa",
    alias: null,
    countryId: 9,
    sortOrder: 11,
  },
  {
    id: 207,
    name: "La Rioja",
    alias: null,
    countryId: 9,
    sortOrder: 12,
  },
  {
    id: 208,
    name: "Misiones",
    alias: null,
    countryId: 9,
    sortOrder: 13,
  },
  {
    id: 209,
    name: "Neuquén",
    alias: null,
    countryId: 9,
    sortOrder: 14,
  },
  {
    id: 210,
    name: "Río Negro",
    alias: null,
    countryId: 9,
    sortOrder: 15,
  },
  {
    id: 211,
    name: "Salta",
    alias: null,
    countryId: 9,
    sortOrder: 16,
  },
  {
    id: 212,
    name: "San Juan",
    alias: null,
    countryId: 9,
    sortOrder: 17,
  },
  {
    id: 213,
    name: "San Luis",
    alias: null,
    countryId: 9,
    sortOrder: 18,
  },
  {
    id: 214,
    name: "Santa Cruz",
    alias: null,
    countryId: 9,
    sortOrder: 19,
  },
  {
    id: 215,
    name: "Santa Fe",
    alias: null,
    countryId: 9,
    sortOrder: 20,
  },
  {
    id: 216,
    name: "Santiago del Estero",
    alias: null,
    countryId: 9,
    sortOrder: 21,
  },
  {
    id: 217,
    name: "Tierra del Fuego",
    alias: null,
    countryId: 9,
    sortOrder: 22,
  },
  {
    id: 218,
    name: "Tucumán",
    alias: null,
    countryId: 9,
    sortOrder: 23,
  },
]
